import { useInitData } from '../../../hooks'
import { getBuildingProfilePathname } from '../../../utils/link'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewPortfolioRow } from '../BirdviewPortfolioRow'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewPropertiesWidget({
  Icon,
  dragHandleProps,
  getProfilePathname = getBuildingProfilePathname,
  section,
  showAllTarget,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget } = useBirdviewListTarget()

  function handleShowAll() {
    onNavigate(getListTarget(showAllTarget))
  }

  function handleOpen(item) {
    onNavigate(getProfilePathname({ availableSections, id: item.id }))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewPortfolioRow
          Icon={Icon}
          item={item}
          key={item.id}
          onOpen={handleOpen}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewPropertiesWidget
